import { Network, UserRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useApi } from "@/modules/collector_v2/hooks/useApi";
import { PageHeader } from "@/modules/collector_v2/components/common/PageHeader";
import { LoadingState } from "@/modules/collector_v2/components/common/LoadingState";
import { ErrorState } from "@/modules/collector_v2/components/common/ErrorState";
import { EmptyState } from "@/modules/collector_v2/components/common/EmptyState";
import { RelationshipRow } from "@/modules/collector_v2/components/common/RelationshipRow";

function SimpleRelationshipMap({ relationships }) {
  const nodes = Array.from(new Set(relationships.flatMap((rel) => [rel.uid_a, rel.uid_b]))).slice(0, 12);
  return (
    <div className="simple-graph">
      {relationships.slice(0, 12).map((rel, index) => (
        <div key={`${rel.uid_a}-${rel.uid_b}`} className="graph-edge" style={{ top: `${12 + (index % 6) * 13}%`, left: `${8 + (index % 4) * 22}%`, width: `${120 + Math.min(160, rel.co_hands * 12)}px` }} />
      ))}
      {nodes.map((uid, index) => (
        <div key={uid} className="graph-node" style={{ top: `${10 + (index % 4) * 22}%`, left: `${10 + ((index * 29) % 76)}%` }} data-testid="relationship-graph-node">
          <UserRound className="h-4 w-4" />
          <span>{uid}</span>
        </div>
      ))}
    </div>
  );
}

export default function RelationshipsPage() {
  const { data, loading, error, refetch } = useApi("/relationships?min_score=0");
  const rels = data?.items || [];
  return (
    <>
      <PageHeader eyebrow="Investigación" title="Relaciones sospechosas" description="Vista de pares con co-ocurrencia, swings de profit y score relacional." action={<Button data-testid="relationships-refresh-button" variant="outline" onClick={refetch}>Refrescar</Button>} />
      {loading && <LoadingState />}
      {error && <ErrorState message={error} onRetry={refetch} />}
      {!loading && !error && rels.length === 0 && <EmptyState title="Sin relaciones todavía" description="Importa lotes de manos para que el motor calcule pares y co-ocurrencias." icon={Network} testid="relationships-empty-state" />}
      {!loading && !error && rels.length > 0 && (
        <div className="relationships-grid" data-testid="relationships-graph-canvas">
          <Card className="relationship-map-card"><CardHeader><CardTitle>Mapa simple de pares</CardTitle><CardDescription>El grosor representa co-ocurrencia/profit swings.</CardDescription></CardHeader><CardContent><SimpleRelationshipMap relationships={rels.slice(0, 16)} /></CardContent></Card>
          <Card><CardHeader><CardTitle>Top relaciones</CardTitle></CardHeader><CardContent className="stack-list">{rels.map((rel) => <RelationshipRow key={`${rel.uid_a}-${rel.uid_b}`} rel={rel} />)}</CardContent></Card>
        </div>
      )}
    </>
  );
}
